import React from 'react'
import { IIconProps } from './IIconProps'

interface IProps extends IIconProps {
  secondColor?: string
}

const IconEmpty: React.FC<IProps> = (props) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 162 134"
  >
    <ellipse
      opacity=".5"
      cx="61.5"
      cy="103"
      rx="61.5"
      ry="31"
      fill={props.secondColor || '#EFEDF8'}
    />
    <path
      stroke={props.color || '#CCC5E7'}
      strokeWidth="4.089"
      strokeLinecap="round"
      d="m72.371 2.245 82.696 96.561"
    />
    <path
      stroke={props.color || '#CCC5E7'}
      strokeWidth="3.067"
      strokeLinecap="round"
      d="m154.636 97.714-32.388 26.673M70.842 2.804l-42.993 8.599M68.248 82.775 32.175 99.863"
    />
    <path
      d="m70.5 81 31-44"
      stroke={props.color || '#CCC5E7'}
      strokeWidth="4.7"
      strokeLinecap="round"
    />
    <path
      stroke={props.color || '#CCC5E7'}
      strokeWidth="5.111"
      strokeLinecap="round"
      d="m68.863 81.767 90.081-20.341"
    />
    <path
      d="M157.442 60.022C100.359 82.529 75.404 30.872 69.597 1.99a.504.504 0 0 0-.6-.392L34.033 8.493a.329.329 0 0 1-.064.006c-.228 0-.383.236-.306.45 26.81 74.093 69.982 79.382 94.737 74.57a.497.497 0 0 0 .187-.079l30.347-20.596c3.021-1.817-.253-3.548-1.383-2.878a.764.764 0 0 1-.108.056Z"
      fill={props.secondColor || '#EFEDF8'}
    />
    <path
      stroke={props.color || '#CCC5E7'}
      strokeWidth="5.111"
      strokeLinecap="round"
      d="m32.745 98.718 26.106-46.152M30.667 99.746l95.146-16.991"
    />
    <path
      stroke={props.color || '#CCC5E7'}
      strokeWidth="4.089"
      strokeLinecap="round"
      d="M26.876 10.5 120.9 126.413"
    />
  </svg>
)

export default IconEmpty
